import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import * as Common from 'common/components';
import { createRoute } from 'lib/util';
const { Form } = Common;

class AssetsFormHistorics extends Component {
  render() {
    return (
      <Fragment>
        <div className="row mt-3 align-items-center bbottom pb-3">
          <div className="col-sm-12">
            <h5>
              <b>{this.props.t('assets.section.historic')}</b>
            </h5>
            <br />
          </div>
          <div className="col-12">
            <div className="mb-2" style={{ position: 'relative' }}>
              <Common.Table>
                <thead>
                  <tr>
                    <th width="15%">{this.props.t('assets.fields.historics.date')}</th>
                    <th width="30%">{this.props.t('assets.fields.historics.user')}</th>
                    <th width="20%">{this.props.t('assets.fields.historics.status')}</th>
                    <th width="35%" className="text-center">
                      {this.props.t('common.actions')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.count === 0 && (
                    <tr>
                      <td colSpan="4">
                        <div className="alert alert-info text-center mb-0">
                          <i className="fa fa-lg fa-info-circle pr-3" />
                          {this.props.t('assets.fields.historics.empty')}
                        </div>
                      </td>
                    </tr>
                  )}
                  {this.props.children}
                </tbody>
              </Common.Table>
              <Common.LoaderOverlay show={this.props.isLoading} />
            </div>
            <Common.Pagination
              {...this.props.pagination}
              handleLimitChange={this.props.handleLimitChange}
              handlePageChange={this.props.handlePageChange}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12 mt-3">
            <Form.Link
              to={createRoute(this.props.company.id, this.props.subcompany.id, 'assets')}
              className={classnames('btn btn-secondary pull-right mr-3', {
                disabled: this.props.isSaving,
              })}
            >
              {this.props.t('actions.cancel')}
            </Form.Link>
            <div className="clearfix" />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default translate()(AssetsFormHistorics);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormHistorics.js